import { getBasePath } from '../../utils/config';
import { safeJsonParse } from 'api/utils/fetchHelpers';
import {
  IgetSalesMatchingAPIBody,
  IgetCatalogReferencesAPIResponse,
  IbrandCatalogFilterAPIResponse,
  IbrandCatalogFilterAPIBody,
  IgetBrandCatalogItemsAPIResponse,
  IgetBrandCatalogAPIBody,
  ImatchSaleAPIBodyItem,
  IsetOwnClientProductAPIBodyItem,
  IunmatchSaleAPIBody,
  IsetOwnClientProductAPIResponse,
  ImatchSaleAPIResponse,
  IunmatchSaleAPIResponse,
} from './salesMatching.response.interface';

export const getSalesMatchingItemAPI = async (
  body: IgetSalesMatchingAPIBody,
  signal: AbortSignal,
  token: string
): Promise<IgetCatalogReferencesAPIResponse> => {
  const params = {
    signal: signal,
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  };
  const response = await fetch(
    `${getBasePath()}/product_management/catalog_sales`,
    params
  );
  return await safeJsonParse(response);
};

export const brandCatalogFilterAPI = async ({
  body,
  token,
}: {
  body: IbrandCatalogFilterAPIBody;
  token: string;
}): Promise<IbrandCatalogFilterAPIResponse> => {
  const params = {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  };
  const response = await fetch(
    `${getBasePath()}/product_management/brand_catalog_filter`,
    params
  );
  return await safeJsonParse(response);
};

export const getBrandCatalogItemsAPI = async ({
  body,
  token,
}: {
  body: IgetBrandCatalogAPIBody;
  token: string;
}): Promise<IgetBrandCatalogItemsAPIResponse> => {
  const params = {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  };
  const response = await fetch(
    `${getBasePath()}/product_management/brand_catalog`,
    params
  );
  return await safeJsonParse(response);
};

export const matchSaleAPI = async (
  body: ImatchSaleAPIBodyItem[],
  token: string
): Promise<ImatchSaleAPIResponse> => {
  const params = {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  };
  const response = await fetch(`${getBasePath()}/product_management/match_sales`, params);
  return await safeJsonParse(response);
};

export const unmatchSaleAPI = async (
  body: Array<IunmatchSaleAPIBody>,
  token: string
): Promise<IunmatchSaleAPIResponse> => {
  const params = {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  };
  const response = await fetch(
    `${getBasePath()}/product_management/unmatch_sales`,
    params
  );
  return await safeJsonParse(response);
};

export const setOwnClientProductAPI = async (
  body: Array<IsetOwnClientProductAPIBodyItem>,
  token: string
): Promise<IsetOwnClientProductAPIResponse> => {
  const params = {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  };
  const response = await fetch(
    `${getBasePath()}/product_management/set_own_client_product`,
    params
  );
  return await safeJsonParse(response);
};
